import {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import CoachConfig from '../Model/CoachConfig';
import useComponentMounted from '../../hooks/useComponentMounted';

const useCoachConfig = (coachId) => {
  const [coachConfig, setCoachConfig] = useState(null);
  const [loading, setLoading] = useState(false);

  const isComponentMountedRef = useComponentMounted();

  const loadCoachConfig = useCallback(async () => {
    setLoading(true);

    const coachConfigDoc = await CoachConfig.getCoachConfigByCoachId(coachId);
    setCoachConfig(coachConfigDoc);

    setLoading(false);
  }, [coachId]);

  useEffect(() => {
    if (!coachId) {
      setCoachConfig(null);
      return;
    }

    if (isComponentMountedRef.current) {
      loadCoachConfig();
    }
  }, [coachId, isComponentMountedRef, loadCoachConfig]);

  return useMemo(() => ({
    coachConfig,
    loading,
  }), [coachConfig, loading]);
};

export { useCoachConfig };
